import { GetCreditorAccountSummaryRequest } from '../types/GetCreditorAccountSummaryRequest';
import CreditorAccountSummaryApi from '../api/CreditorAccountSummaryApi';
import { CreditorAccountSummary } from '../types/CreditorAccountSummary';

export default {
  getCreditorAccountSummary: async(request: GetCreditorAccountSummaryRequest): Promise<CreditorAccountSummary> => {
    return await CreditorAccountSummaryApi.getCreditorAccountSummary(request);
  }
}